import i18next from "i18next";
import { inject } from "mobx-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "../../components/catalog/TrackList.style.scss";
import { Site } from "@ihr-radioedit/inferno-core";
import { reverseRoute } from "@inferno/renderer-shared-core";
import { Container, Tab, Tabs } from "../../ui";
import type { PageBlockInterface } from "../Block.component";
import { CurrentTracksLoader } from "./CurrentTracksLoader.component";
import "./MusicPage.style.scss";
import { TopTrackLoader } from "./TopTrackLoader.component";
import type { Store } from "@inferno/renderer-shared-core";

interface PlaylistProps extends PageBlockInterface {
  store?: Store;
}

function updatePath({ selectedTab, site }: { selectedTab: string; site: Site }) {
  const url =
    selectedTab === i18next.t("recently_played")
      ? reverseRoute(site, "music_recently_played")
      : reverseRoute(site, "music_top_songs");
  history.replaceState({}, "", url);
}

export const TAKE = 20;

export const MusicPage = inject("store")(({ block, isPrimary, store }: PlaylistProps) => {
  if (!store) {
    return null;
  }
  const { site } = store;

  const { t } = useTranslation();

  useEffect(() => {
    if (store && block) {
      store.storeBlock(block);
    }
  });

  return (
    <Container className="music-page" block={false}>
      <Tabs
        onSelect={context => updatePath({ ...context, site })}
        selectedTab={block.type === "playlist" ? t("recently_played") : t("top_songs")}
      >
        <Tab label={t("recently_played")}>
          <CurrentTracksLoader block={block} />
        </Tab>
        <Tab label={t("top_songs")}>
          <TopTrackLoader block={block} isPrimary={isPrimary} songsToTake={TAKE} onMusicPage={true} />
        </Tab>
      </Tabs>
    </Container>
  );
});

export default MusicPage;
